import React from "react";
import styled from "styled-components";
import { Row, Stack } from "react-bootstrap";
import Table from "./Table";
import { DetalleProducto } from "../Model";

function TableSection({
  total,
  items,
  onProductoValorChange,
}: {
  total: number;
  items: Map<string, DetalleProducto>;
  onProductoValorChange: (idProducto: string, valor: number) => void;
}) {
  return (
    <Row>
      <ResponsiveTableSection>
        <TableWrapper>
          <Stack gap={2}>
            <Table
              total={total}
              items={items}
              onProductoValorChange={onProductoValorChange}
            />
          </Stack>
        </TableWrapper>
      </ResponsiveTableSection>
    </Row>
  );
}

const ResponsiveTableSection = styled("div")`
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const TableWrapper = styled("div")`
  position: relative;
  clear: both;
  zoom: 1;
`;

export default TableSection;
